var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcCheckGray = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "968DB96A-A4AD-47DF-8C46-5E4399836A9A")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin-DJ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01108-\\u201CCourses\\u201D-page",
    transform: "translate(-1252.000000, -341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-list-Copy",
    transform: "translate(296.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(12.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Primary-Copy-5",
    transform: "translate(908.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_check_orange",
    transform: "translate(36.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73466667,9.17333333 L8.676,10.1146667 L14.32,4.47066667 L15.2626667,5.41333333 L8.676,12 L4.43333333,7.75733333 L5.376,6.81466667 L6.79266667,8.23133333 L7.73466667,9.17266667 L7.73466667,9.17333333 Z M7.736,7.288 L11.0373333,3.986 L11.9773333,4.926 L8.676,8.228 L7.736,7.288 Z M5.85133333,11.058 L4.90933333,12 L0.666666667,7.75733333 L1.60933333,6.81466667 L2.55133333,7.75666667 L2.55066667,7.75733333 L5.85133333,11.058 L5.85133333,11.058 Z",
    id: "Shape",
    fill: "#495057",
    fillRule: "nonzero"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCheckGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_check_gray.74ab3b08.svg";
export { ForwardRef as ReactComponent };